import { createQueryKeys } from "../../../shared/utils/create-query-keys";

export const cicoIssuesVisitsQueryKeys = createQueryKeys("cico_issues_visits", {
  search: (params: Record<string, unknown>) => params,
  visits: null,
});
